(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-promo')) {
    customElements.define(
      'product-promo',
      class extends HTMLElement {
        connectedCallback() {
          this.lifecycle?.abort();
          this.lifecycle = new AbortController();
          const signal = this.lifecycle.signal;
          this.cookieName = `product_promo_${this.dataset.sectionId}_${this.dataset.productId}`;
          this.addEventListener(
            'click',
            (event) => {
              if (!event.target.closest('.product-promo__close')) return;
              const restoreFocus = this.contains(document.activeElement);
              this.hidden = true;
              if (!window.Shopify?.designMode) {
                const days = Number(this.dataset.cookieDays) || 1;
                const secure = location.protocol === 'https:' ? '; Secure' : '';
                document.cookie = `${this.cookieName}=dismissed; Max-Age=${
                  days * 86400
                }; Path=/; SameSite=Lax${secure}`;
              }
              if (restoreFocus) {
                const main = document.getElementById('MainContent');
                if (main) {
                  if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
                  main.focus({ preventScroll: true });
                }
              }
            },
            { signal }
          );
          document.addEventListener(
            'shopify:section:select',
            (event) => {
              if (event.detail?.sectionId === this.dataset.sectionId) this.hidden = false;
            },
            { signal }
          );
          if (window.Shopify?.designMode) {
            this.hidden = false;
          } else if (!document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${this.cookieName}=`))) {
            this.timer = setTimeout(() => {
              this.hidden = false;
            }, 3000);
          }
        }
        disconnectedCallback() {
          clearTimeout(this.timer);
          this.lifecycle?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
